import VaultScreen from "@/components/vault/VaultPage";

export default function VaultPage() {
  return <VaultScreen />;
}
